import { brand } from "../../theme";
import { Box, Typography, Container, Button } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Link } from "react-router-dom";
import AetnaLogo from "../../assets/images/insurance/aetna.png";
import CignaLogo from "../../assets/images/insurance/cigna.png";
import OscarLogo from "../../assets/images/insurance/oscar.png";
import OxfordLogo from "../../assets/images/insurance/oxford.png";
import UnitedLogo from "../../assets/images/insurance/united.png";

const insuranceProviders = [
  { name: "Aetna", logo: AetnaLogo },
  { name: "Cigna", logo: CignaLogo },
  { name: "Oscar", logo: OscarLogo },
  { name: "Oxford", logo: OxfordLogo },
  { name: "United", logo: UnitedLogo },
];

const InsuranceStrip = () => {
  return (
    <Box
      sx={{
        py: { xs: 5, md: 6 },
        backgroundColor: "secondary.light",
        borderTop: brand.borderSoft,
        borderBottom: brand.borderSoft,
      }}
    >
      <Container maxWidth="lg">
        <Box sx={{ textAlign: "center", mb: { xs: 3, md: 4 } }}>
          <Typography
            component="h2"
            variant="h6"
            sx={{
              fontSize: { xs: "1rem", md: "1.1rem" },
              fontWeight: 500,
              color: "#666",
              letterSpacing: "0.05em",
              textTransform: "uppercase",
            }}
          >
            Insurance Accepted
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center",
            gap: { xs: 3, sm: 4, md: 6 },
          }}
        >
          {insuranceProviders.map((provider) => (
            <Box
              key={provider.name}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                opacity: 0.75,
                transition: "all 0.3s ease",
                filter: "grayscale(20%)",
                "&:hover": {
                  opacity: 1,
                  filter: "grayscale(0%)",
                  transform: "scale(1.05)",
                },
              }}
            >
              <img
                src={provider.logo}
                alt={`${provider.name} insurance accepted`}
                style={{
                  height: "40px",
                  width: "auto",
                  maxWidth: "120px",
                  objectFit: "contain",
                }}
              />
            </Box>
          ))}
        </Box>

        <Box sx={{ textAlign: "center", mt: { xs: 3, md: 4 } }}>
          <Button
            component={Link}
            to="/insurance"
            variant="outlined"
            endIcon={<ArrowForwardIcon sx={{ fontSize: 18 }} />}
            sx={{
              fontSize: { xs: "0.875rem", md: "0.95rem" },
              color: "primary.dark",
              borderColor: "primary.light",
              backgroundColor: "#fff",
              fontWeight: 600,
              textTransform: "none",
              borderRadius: "8px",
              px: 3,
              py: 1,
              transition: "background-color 0.2s ease, border-color 0.2s ease",
              "&:hover": {
                borderColor: "primary.main",
                backgroundColor: "rgba(255, 255, 255, 0.7)",
              },
            }}
          >
            View insurance details
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default InsuranceStrip;
